import React, { Fragment, useState, useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import "react-datepicker/dist/react-datepicker.css";
import CartProvider from "../../store/CartProvider";
import classes from "./CheckoutModel.module.css";
import CartContext from "../../store/cart-context";

const Backdrop = (props) => {
  return <div className={classes.backdrop} onClick={props.onHideCart}></div>;
};

const ModalOverlay = (props) => {
  return (
    <div className={classes.modal}>
      <div className={classes.content}>{props.children}</div>
      {props.orderPlaced && (
        <div className={classes.orderPlaced}>
          <p>
            Your order has been placed successfully, Please keep cash ready for
            payment upon delivery!
          </p>
        </div>
      )}
    </div>
  );
};

const CheckoutModal = (props) => {
  
  const cartCtx = useContext(CartContext);
  const totalAmmount = `₹ ${cartCtx.totalAmount}`;

  const portalElement = document.getElementById("overlays");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",
    paymentMethod: "creditCard",
    cardNumber: "",
    expiryDate: null,
    cvv: "",
    mobileNumber: "", // Add the mobileNumber property with an empty string value
  });

  const [currentStep, setCurrentStep] = useState(1);
  const [userOTP, setUserOTP] = useState("");
  const [wrongOTP, setWrongOTP] = useState(false);
  const [orderPlaced, setOrderPlaced] = useState(false);
  const payment = "cash on delivery";
  const inputChangeHandler = (event) => {
    const { id, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  useEffect(() => {
    let timer;
    if (wrongOTP) {
      timer = setTimeout(() => {
        setWrongOTP(false);
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, [wrongOTP]);

  const submitHandler = (event) => {
    event.preventDefault();
    if (currentStep === 1) {
      if (validateForm()) {
        setCurrentStep(2);
      }
    } else if (currentStep === 2) {
      if (validateOTP()) {
        const orderInfo = {
          ...formData,
          totalAmount: calculateTotalPayment(),
        };
        handleOrderPlacement(orderInfo);
      }
    }
  };

  const validateForm = () => {
    const { name, email, address, paymentMethod, mobileNumber } = formData;
    if (paymentMethod === "creditCard") {
      return (
        name.trim() !== "" &&
        email.trim() !== "" &&
        address.trim() !== "" &&
        mobileNumber.trim() !== "" // Add validation for mobileNumber
      );
    } else if (paymentMethod === "cashOnDelivery") {
      return (
        name.trim() !== "" &&
        email.trim() !== "" &&
        address.trim() !== "" &&
        mobileNumber.trim() !== ""
      );
    }
  };

  const validateOTP = () => {
    const code = userOTP.trim();
    if (code.length !== 6 || isNaN(code)) {
      setWrongOTP(true);
      return false;
    }
    setWrongOTP(false);
    return true;
  };

  const nextStepHandler = () => {
    if (validateForm()) {
      setCurrentStep(2);
    }
  };

  const calculateTotalPayment = () => {
    let totalAmount = `₹ ${cartCtx.totalAmount}`;
    return totalAmount;
  };

  const generateOTP = () => {};

  const handleOrderPlacement = (orderInfo) => {
    setFormData({
      name: "",
      email: "",
      address: "",
      paymentMethod: "creditCard",
      mobileNumber: "",
      expiryDate: null,
    });

    setOrderPlaced(true);

    setTimeout(() => {
      setOrderPlaced(false);
      window.location.reload();
    }, 3000);
  };

  return (
    <Fragment>
      {ReactDOM.createPortal(
        <Backdrop onHideCart={props.onHideCart} />,
        portalElement
      )}
      {ReactDOM.createPortal(
        <ModalOverlay orderPlaced={orderPlaced}>
          {currentStep === 1 && (
            <form onSubmit={submitHandler}>
              <div className={classes.control}>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  value={formData.name}
                  onChange={inputChangeHandler}
                />
              </div>
              <div className={classes.control}>
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={formData.email}
                  onChange={inputChangeHandler}
                />
              </div>
              <div className={classes.control}>
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  id="address"
                  value={formData.address}
                  onChange={inputChangeHandler}
                />
              </div>
              <div className={classes.control}>
                <label htmlFor="address">Mobile Number</label>
                <input
                  type="text"
                  id="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={inputChangeHandler}
                />
              </div>
              <div className={classes.control}>
                <label htmlFor="paymentMethod">Payment Method</label>
                <select
                  id="paymentMethod"
                  value={formData.paymentMethod}
                  onChange={inputChangeHandler}
                >
                  <option value="cashOnDelivery">Cash on Delivery</option>
                </select>

                <p>Total amount: {totalAmmount}</p>
              </div>

              {/* {formData.paymentMethod === "creditCard" && (
                <div className={classes.control}>
                  <label htmlFor="cardNumber">Phone Number</label>
                  <input
                    type="text"
                    id="cardNumber"

                    onChange={inputChangeHandler}
                  />
                </div>
              )} */}
              {/* {formData.paymentMethod === "creditCard" && (
                <div className={classes.control}>
                  <label htmlFor="expiryDate">Expiry Date</label>
                  <DatePicker
                    id="expiryDate"
                    selected={formData.expiryDate}
                    onChange={(date) =>
                      setFormData((prevState) => ({
                        ...prevState,
                        expiryDate: date,
                      }))
                    }
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    placeholderText="MM/YYYY"
                  />
                </div>
              )} */}
              {/* {formData.paymentMethod === "creditCard" && (
                <div className={classes.control}>
                  <label htmlFor="cvv">CVV</label>
                  <input
                    type="text"
                    id="cvv"
                    value={formData.cvv}
                    onChange={inputChangeHandler}
                  />
                </div>
              )} */}
              <div className={classes.actions}>
                <button type="button" onClick={props.onHideCart}>
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={nextStepHandler}
                  disabled={!validateForm()}
                >
                  Next
                </button>
              </div>
            </form>
          )}
          {currentStep === 2 && (
            <form onSubmit={submitHandler}>
              {formData.paymentMethod === "cashOnDelivery" && (
                <p>Please keep cash ready for payment upon delivery.</p>
              )}
              <div className={classes.control}>
                <label htmlFor="otp">OTP</label>
                <input
                  type="text"
                  id="otp"
                  value={userOTP}
                  onChange={(event) => setUserOTP(event.target.value)}
                  placeholder="123456"
                />
              </div>
              <div>
                <p>Total Amount: {totalAmmount}</p>
                <p>Payment Method: {payment}</p>
              </div>
              {wrongOTP && (
                <p className={classes.error}>Invalid OTP. Please try again.</p>
              )}
              <div className={classes.actions}>
                <button type="button" onClick={() => setCurrentStep(1)}>
                  Back
                </button>
                <button type="submit" disabled={userOTP.trim() === ""}>
                  Place Order
                </button>
              </div>
            </form>
          )}
        </ModalOverlay>,
        portalElement
      )}
    </Fragment>
  );
};

export default CheckoutModal;
